import { UserActiveBranch } from "@/types/branch";
import { api } from "@/utils/axiosInterceptor";
import { useQuery } from "@tanstack/react-query";

export const useCurrentActiveBranch = () => {
    const {
    	data: currentActiveBranch,
  	} = useQuery({
    	queryKey: ["currentActiveBranch"],
    	queryFn: async () => {
      	const response = await api.get<UserActiveBranch>("/active-branch");

      	return response.data;
    	},
  	});

    return {
        currentActiveBranch: currentActiveBranch
    }
}